export default __webpack_public_path__ + "static/media/screen_google_calendar_02.0c8d6d13.png";